import { Fragment } from 'react';
import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from '@/partials/toolbar';
import { useLayout } from '@/providers';
import { usePermissions } from '@/hooks/usePermissions';
import { useNavigate } from 'react-router-dom';
import { ProductVatConfigListings } from './ProductVatConfigListings';
import {
  defaultProductVatConfigScreen,
  type ProductVatConfigScreenConfig,
} from './productVatConfigScreenConfig';

interface ProductVatConfigManagementProps {
  screenConfig?: ProductVatConfigScreenConfig;
}

const ProductVatConfigManagement = ({
  screenConfig = defaultProductVatConfigScreen,
}: ProductVatConfigManagementProps) => {
  const { currentLayout } = useLayout();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const handleCreateNavigate = () =>
    navigate(`${screenConfig.basePath}/create`);

  return (
    <Fragment>
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="product-vat-config-management-heading" />
              <ToolbarDescription>
                {screenConfig.managementDescription}
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              {hasPermission('product_vat_config_management_create') && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={handleCreateNavigate}
                  aria-label={screenConfig.createButtonLabel}
                >
                  {screenConfig.createButtonLabel}
                </button>
              )}
            </ToolbarActions>
          </Toolbar>
        </Container>
      )}
      <Container>
        <ProductVatConfigListings screenConfig={screenConfig} />
      </Container>
    </Fragment>
  );
};

export { ProductVatConfigManagement };
